import { useApiQuery } from '@portals-platform/api-client';
import { ENDPOINTS } from '../api/endpoints.js';
import type { CertificateTemplateResponse } from '../api/responses.js';
import { queryKeys } from '../query-keys.js';

const NO_ITEMS: never[] = [];

export function useCertificateTemplatesByCountry(countryCode: string) {
  const { data, isLoading } = useApiQuery<CertificateTemplateResponse[]>(
    [...queryKeys.certificateTemplatesByCountry(countryCode)],
    ENDPOINTS.certificateTemplatesByCountry(countryCode),
    undefined,
    { enabled: Boolean(countryCode) },
  );

  return { templates: data ?? NO_ITEMS, isLoading };
}
